import { actionCoreApi } from "core/utils/api";
import { actionErrorNotifier } from "core/utils/helpers";
import TenantConstants from "secure-pages/tenants/Tenants.constants";
import HTTPUrlHelper from "shared/helpers/HTTPUrlHelper";

export const fetchServicesByAccountId = (id: string): ActionType =>
    actionErrorNotifier(actionCoreApi(
      TenantConstants.AccountServices,
      HTTPUrlHelper.getAccountServicesByIdAPI(id)
    ))

 export const fetchServicesByUserId = (id: string): ActionType =>
    actionErrorNotifier(actionCoreApi(
      TenantConstants.AccountServices,
      HTTPUrlHelper.getAccountServicesByUserIdAPI(id)
    ))